import { useState } from 'react';
import { DaDataParty } from 'react-dadata';
import { DaDataSuggestion } from 'react-dadata/dist/types';
import { useFormContext } from 'react-hook-form';
import { useMutation } from 'react-query';

import { setLocalStorage } from '../../../common/util/localStorage';
import { useActions } from '../../../hooks/useActions';
import { useBasket } from '../../../hooks/useBasket';
import { useUser } from '../../../hooks/useUser';
import { BasketService } from '../../../service/basket/basket.service';
import { IUpdateOrg } from '../../../types/basket';
import { setStoreLocal } from '../../../utils/local-storage';

export const useUpdateOrg = () => {
  const { setHandleModal, setAddOrganization, setUser, setCheckoutValues } =
    useActions();
  const { user } = useUser();
  const { orgValue: value, checkout } = useBasket();
  const { setValue } = useFormContext();
  const dataValue: IUpdateOrg = {
    firstname: 'покупатель',
    surname: '',
    middlename: '',
    email: String(user?.email),
    type: 'organization',
    phone: String(user?.phone),
    enable: true,
    inn: value?.inn,
    kpp: value?.kpp,
    org_name: value?.name?.short_with_opf,
    org_name_print: value?.name?.short_with_opf,
    legal_address: value?.address?.unrestricted_value,
    mailing_address: value?.address?.unrestricted_value,
  };
  const handleCloseModal = () => {
    setHandleModal(false);
  };
  const { mutateAsync, isLoading } = useMutation(
    'update org',
    (data: IUpdateOrg) => BasketService.updateOrg(data),
    {
      onSuccess: () => {
        setStoreLocal('org_value', dataValue);
        const addUser = {
          ...user,
          org_name: dataValue.org_name,
          legal_address: dataValue.legal_address,
          inn: dataValue.inn,
          kpp: dataValue.kpp,
        };
        setUser(addUser);
      },
    }
  );

  //Отправить данные
  const onSubmit = async () => {
    const addName = {
      ...user,
      org_name: dataValue.org_name,
    };
    //Добавляем состояние в Redux
    await mutateAsync(dataValue);
    setHandleModal(false);
    setCheckoutValues({ ...checkout, orgName: dataValue.org_name });
    setValue('orgName', dataValue.org_name);
    setStoreLocal('profile', addName);
  };
  //Наименование изменено
  const handleChange = async (suggestion?: DaDataSuggestion<DaDataParty>) => {
    setAddOrganization(suggestion?.data as DaDataParty);
    await BasketService.getSuggestionsData(String(suggestion?.value));
  };

  const onClearValue = () => {
    setStoreLocal('org_value', {});
    setAddOrganization({} as DaDataParty);
  };
  const isValue = value && Object.keys(value).length !== 0;
  return {
    onSubmit,
    handleChange,
    value,
    handleCloseModal,
    onClearValue,
    isValue,
    isLoading,
  };
};
